module.exports = __webpack_public_path__ + "static/media/IMG_20210421_161729_174.f843b936.jpg";